
<template>
<!--  <el-dialog :visible.sync="dialogVisible"  @close="handleClose">-->
    <div class="dialog" v-loading="loading">
      <el-form ref="form" :rules="formRules" :model="form" label-width="130px" >
        <el-form-item label="关联培训项目" style="width: 100%" prop="training">
          <el-select v-model="form.training" clearable placeholder="请选择培训项目"  style="width: 95%">
            <el-option
                v-for="item in trainOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="考试时间" style="width: 100%"  prop="examTime">
          <el-date-picker
              style="width:95%"
              v-model="form.examTime"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              range-separator="至"
              @change="handleChangeTime"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="考试时长" class="half" prop="exam_duration">
          <el-select v-model="form.exam_duration" clearable placeholder="请选择考试时长"  style="width: 85%">
            <el-option
                v-for="item in options2"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>分钟
        </el-form-item>
        <el-form-item label="总分" class="half"  prop="total_scores">
          <el-input v-model="form.total_scores"></el-input>分
        </el-form-item>
        <el-form-item label="合格分" class="half"  prop="pass_scores">
          <el-input v-model="form.pass_scores"></el-input>分
        </el-form-item>
        <el-form-item label="可考次数" class="half"  prop="exam_times">
          <el-input v-model="form.exam_times"></el-input>次
        </el-form-item>
        <el-form-item label="考题总数" class="half"  prop="total_questions">
          <el-input v-model="form.total_questions"></el-input>题
        </el-form-item>
      </el-form>
    </div>
<!--  </el-dialog>-->
</template>
<script>
import {getExamDtl, getTrainOptions} from "@/api/training";

export default {
  name: "addDialog",
  props: {
    examId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: false,
      form:{
        training:  '',
        exam_duration: '',
        start_time: '',
        end_time: '',
        total_scores: '',
        pass_scores: '',
        exam_times: '',
        total_questions: '',
        is_publish: '',
        examTime:[],
      },
      dialogVisible: false,
      value: [],
      options2: [
        {value: '10', label: '10'},
        {value: '20', label: '20'},
        {value: '30', label: '30'},
        {value: '40', label: '40'},
        {value: '50', label: '50'},
        {value: '60', label: '60'},
        {value: '70', label: '70'},
        {value: '80', label: '80'},
        {value: '90', label: '90'},
        {value: '100', label: '100'},
        {value: '110', label: '110'},
        {value: '120', label: '120'},
      ],
      trainOptions: [],

      formRules: {
        training: [
          { required: true, message: '请选择培训项目', trigger: 'change' }
        ],
        exam_duration: [
          { required: true, message: '请选择考试时长', trigger: 'change' }
        ],
        examTime: [
          { required: true, message: '请选择考试时间', trigger: 'change' }
        ],

        total_scores: [
          { required: true, message: '请输入总分', trigger: 'blur' }
        ],
        pass_scores: [
          { required: true, message: '请输入合格分', trigger: 'blur' }
        ],
        exam_times: [
          { required: true, message: '请输入可考次数', trigger: 'blur' }
        ],
        total_questions: [
          { required: true, message: '请输入考题总数', trigger: 'blur' }
        ],

      }
    };
  },
  created() {
    if(!this.examId){
      this.getTrainOptions()
    }

    if(this.examId){ //如果是编辑请求考试详情
      this.getDtl()
    }else{
      this.form = {
        training:  '',
        exam_duration: '',
        start_time: '',
        end_time: '',
        total_scores: '',
        pass_scores: '',
        exam_times: '',
        total_questions: '',
        is_publish: '',
        examTime: [],
      }
    }
  },
  methods: {
    getDtl(){
      if(this.examId){
        this.loading =  true
        getExamDtl({id: this.examId}).then(res => {
          const d = res.data || {}
          // 一次性整体赋值，保证所有字段（含 examTime）都是响应式的。
          // 不能先 this.form = res.data 再 this.form.examTime = [...]：
          // Vue 2 对已观察对象新增属性不会触发视图更新，会导致编辑时输入框不变
          this.form = {
            ...d,
            training: d.training,
            start_time: d.start_time,
            end_time: d.end_time,
            examTime: (d.start_time && d.end_time) ? [d.start_time, d.end_time] : [],
          }
          this.getTrainOptions()
        }).finally(() => {
          this.loading = false
        })
      }

    },
    getTrainOptions() {
      getTrainOptions().then(res => {
        this.trainOptions = res.data.map(item => {
          return {
            value: item.training,
            label: item.title
          }
        })
            let trainObj = {}
        if(this.examId && this.form.training){

          trainObj = {
            value: this.form.training,
            label: this.form.training_title
          }
          this.trainOptions.unshift(trainObj)
        }


      })
    },
    handleChangeTime(){
      this.form.start_time = this.form.examTime[0] + ' ' + '00:00:00'
      this.form.end_time = this.form.examTime[1] + ' ' + '23:59:59'
    },
    // 提交前的校验form必填
    validateForm() {
      return new Promise((resolve) => {
        this.$refs.form.validate(valid => {
          resolve(valid);
        })
      })
    },

  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form-item{
  display: inline-block;
}
.half{
  width: 50%;
}
::v-deep .half .el-input{
  width: 88%;
  margin-right: 8px;
}
::v-deep .el-input .el-input__inner{
  width: 100%;
}
::v-deep .el-radio{
  display: block;
  vertical-align: middle;
  line-height: 40px;
}
.upload-demo{
  display: inline-block;
  width: 50%;
}
.video-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.video-uploader .el-upload:hover {
  border-color: #409eff;
}
.video-preview {
  margin-top: 10px;
}
.dialog{
   padding: 0 90px!important;
}

</style>